
export default  [
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'select-custom',
        field: 'laboratorio',
        label: 'Laboratório',
        option: {
            key: 'id',
            label: 'nome',
            value: 'object'
        },
        info: 'Para cadastrar um novo laboratório por favor acesso o menú: LTCAT > Laboratórios',
        rules: ['required']
    },
];




// WEBPACK FOOTER //
// ./src/components/apps/web/fator-risco/_form/laboratorio-cadastrar.js